<template>
  <div class="reviewTeacher">
    <template v-if="isReviewIndex">
      <!-- title -->
      <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
      <!-- 表单 & 表格 -->
      <ots-table-group-new
        :selectList="selectList"
        :requestForm="requestForm"
        @search="searchList"
        :tableHeader="tableHeader"
        :tableData="tableData"
        :pagination="pagination"
        @changeNum="changeNum"
        @changePage="changePage"
      >
      </ots-table-group-new>
      <!-- 新增 (弹窗) -->
      <ots-custom-dialog :dialog.sync="downDialog" :title="isAddorEdit ? '新增评阅教师' : '编辑评阅教师'">
        <template v-slot:content>
          <div class="exportDialog addReviewTeacher">
            <el-form :model="addRequestForm" ref="addRequestForm" :rules="addRules">
              <el-form-item label="教师姓名" prop="teacherName">
                <el-input v-model.trim="addRequestForm.teacherName" placeholder="请输入"></el-input>
              </el-form-item>      
              <el-form-item label="用户名" prop="userName">
                <el-input v-model.trim="addRequestForm.userName" placeholder="请输入" :disabled="!isAddorEdit"></el-input>
              </el-form-item> 
              <el-form-item label="密码" prop="password" v-if="isAddorEdit" class="resetPassword">
                <el-input v-model.trim="addRequestForm.password" placeholder="请输入密码" type="text" class="no-autofill-pwd"></el-input>
                <ots-password-tooltip></ots-password-tooltip>
              </el-form-item> 
              <el-form-item label="手机号" prop="phone">
                <el-input v-model.number="addRequestForm.phone" placeholder="请输入"></el-input>
              </el-form-item>       
              <el-form-item label="课程" class="courseIds" prop="courseIds">
                <div class="checkCourse">
                  <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" style="width:100%">全选</el-checkbox>
                  <div style="margin: 15px 0;"></div>
                  <el-checkbox-group v-model="addRequestForm.courseIds" @change="handleCheckedUsersChange">
                    <el-checkbox v-for="item in courseData" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                  </el-checkbox-group>                
                </div>
              </el-form-item>     
              <el-form-item label="启用状态" class="addStatus">
                <el-switch v-model="addRequestForm.state" :active-value="1" :inactive-value="0"></el-switch>
              </el-form-item> 
            </el-form>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="downDialog = false">取消</el-button>
          <el-button round type="primary" @click="addOrEditReviewTeacher('addRequestForm')">确定</el-button>
        </template>
      </ots-custom-dialog>
      <!-- 导入 -->
      <ots-custom-dialog :dialog.sync="baseImportDialog" title="评阅教师导入">
        <template v-slot:content>
          <div class="exportDialog">
            <el-form ref="exportForm" :model="importForm">
              <el-form-item label="1.模板下载">
                <span style="color: #006aff" @click="$getStaticFile('评阅教师导入模板.xlsx')" class="cp">
                  <i class="el-icon-download"></i>
                  下载评阅教师导入数据模板
                </span>
              </el-form-item>
              <el-form-item label="2.导入文件" v-model="importForm.Filedata">
                <ots-upload-file :httpRequest="handleFormData" fileType="xlsx"/>
              </el-form-item>
            </el-form>
            <div class="impExplain">
              <span class="tipTitle"><i></i>提示：</span>
              <div>
                <div>1：模板中<span class="col_red">*</span>字段为必填项</div>
                <div>
                  2：只能上传扩展名为<span class="col_red">.xlsx</span>的文件；
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="baseImportDialog = false">取消</el-button>
          <el-button round type="primary" @click="rightImport">导入</el-button>
        </template>
      </ots-custom-dialog>
      <!-- 重置密码 -->
      <ots-custom-dialog :dialog.sync="resetDialog" title="重置密码" width="480px">
        <template v-slot:content>
          <div class="exportDialog resetPassword">
            <el-form :model="resetPasswordForm" :rules="passwordRules" ref="resetPasswordForm">
              <el-form-item label="用户名">
                <el-input v-model.trim="resetPasswordForm.userName" disabled></el-input>
              </el-form-item> 
              <el-form-item label="姓名">
                <el-input v-model.trim="resetPasswordForm.teacherName" disabled></el-input>
              </el-form-item> 
              <el-form-item label="密码" prop="password" style="position: relative;">
                <el-input v-model.trim="resetPasswordForm.password" placeholder="请输入密码" type="password"></el-input>
                <ots-password-tooltip></ots-password-tooltip>
              </el-form-item> 
              <el-form-item label="确认密码" prop="repassword">
                <el-input v-model.trim="resetPasswordForm.repassword" placeholder="确认密码必须和密码相同" type="password"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="resetDialog = false">取消</el-button>
          <el-button round type="primary" @click="resetPasswordFn('resetPasswordForm')">确定</el-button>
        </template>
      </ots-custom-dialog>
    </template>
    <template v-else>
      <router-view></router-view>
    </template>
  </div>
</template>

<script>
import { checkChinese, passWordStrength } from "@/common/verify.js";
import { getSelectCourse } from '@/http/modules/baseSet/course'
import { getTeacherList, ReviewTeacherSet, delReTeacher, importReTeacher, editReviewPsd } from "@/http/modules/markPaper"
export default {
  data() {
    
    return {
      /* ** 新增导入按钮 ** */
      mainTopBtnList: [
        { title: "新增", plain: true, fn: this.addTeacher },
        { title: "导入", fn: this.exportTeacher },
      ],
      /* ** 表单配置 ** */
      selectList: [
        {
          title: "教师姓名",
          type: "input",
          requestKey: "teacherName",
          placeholder: "请输入"
        },
        {
          title: "用户名",
          type: "input",
          requestKey: "userName",
          placeholder: "请输入"
        },
        {
          title: "状态",
          type: "select",
          requestKey: "state",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
            { id: 1, name: "启用" },
            { id: 0, name: "停用" }
          ]
        },
        {
          title: "课程",
          type: "select",
          requestKey: "courseId",
          label: "name",
          value: "id",
          data: []
        }
      ],
      /* ** 请求参数 ** */
      requestForm: {
        teacherName: "",
        userName: "",
        state: "",
        courseId: "",
        page: 1,
        size: 10,
      },
      /* ** 表格配置 ** */
      tableHeader: [
        {
          title: "教师姓名",
          prop: "teacherName",
        },
        {
          title: "用户名",
          prop: "userName",
        },
        {
          title: "手机号",
          prop: "phone",
        },
        {
          title: "课程",
          prop: "courseName",
        },
        {
          title: "启用状态",
          type: "switch",
          prop: "state",
          switchChange:this.changeState
        },
        {
          title: "操作",
          type: "buttons",
          width: "165",
          fixed: "right",
          align: "right",
          headerAlign: "right",
          btnList: [
            {
              title: "重置密码",
              click: this.repeatPsd,
            },
            {
              title: "编辑",
              click: this.editTeacher,
            },
            {
              title: "删除",
              click: this.delTeacher,
            },
          ],
        },
      ],
      tableData: [],
      pagination: {
        total: 0,
      },
      /* ** 新增(弹窗相关) ** */
      isAddorEdit: true,
      downDialog: false,
      addRequestForm: {
        teacherName: "",
        userName: "",
        password: "",
        phone: "",
        courseIds: [],
        state: 1,
      },
      addRules: {
        teacherName: [
          {required: true, message: "请输入教师姓名", trigger: "blur"}
        ],
        userName: [
          {required: true, message: "请输入用户名", trigger: "blur"},
          { validator: checkChinese, trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: passWordStrength, trigger: "blur" },
        ],
        phone: [
          {validator: this.isCheckPhone, trigger: "blur" },
        ],
        courseIds: [
          {required: true, message: "请选择课程", trigger: "change"}
        ]
      },
      isIndeterminate: false,
      checkAll: false,
      courseData: [],
      /* ** 导入 ** */
      baseImportDialog: false,
      importForm: {
        file: "",
      },
      /* ** 重置密码 ** */
      resetDialog: false,
      resetPasswordForm: {
        teacherId: "",
        userName: "",
        teacherName: "",
        password: "",
        repassword: "",
      },
      passwordRules: {
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: passWordStrength, trigger: "blur" },
        ],
        repassword: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          { validator: this.confirmPassword, trigger: "blur" },
        ]
      }
    }
  },
  mounted(){
    this.initData();
    this.search();
  },
  computed: {
    // 是否展示"评阅教师管理"首页
    isReviewIndex(){
      return this.$route.name == "reviewTeacher";
    },
  },
  methods: {
    /***********************
     * @this 初始化数据
     **********************/
    async initData(){
      const { data } = await getSelectCourse();
      this.courseData = data;
      this.selectList[3].data = [
        {id: "", name: "全部"},
        ...data,
      ]
    },

    /***********************
     * @this 搜索
     **********************/
    search(){
      let params = {...this.requestForm};
      getTeacherList(params).then( res => {
        if (res.code == 1) {
          this.tableData = res.data.records;
          this.pagination.total = res.data.total;
        }
      })
    },

    /***********************
     * @this 搜索按钮
     **********************/
    searchList(){
      this.requestForm.size = 10;
      this.requestForm.page = 1;
      this.search();
    },

    /***********************
     * @this 添加
     **********************/
    addTeacher(){
      this.addRequestForm = {
        teacherName: "",
        userName: "",
        password: "",
        phone: "",
        courseIds: [],
        state: 1,
      },
      this.downDialog = true;
      this.isAddorEdit = true;
    },

    /***********************
     * @this 编辑
     **********************/
    editTeacher(row){
      this.addRequestForm = {...row};
      this.addRequestForm.courseIds = this.addRequestForm.courseIds ? this.addRequestForm.courseIds.split(',') : [];
      this.addRequestForm.phone = this.addRequestForm.phone ? this.addRequestForm.phone : "";
      this.downDialog = true;
      this.isAddorEdit = false;
      this.isIndeterminate = true;
    },

    /***********************
     * @this 执行添加/编辑
     **********************/
    addOrEditReviewTeacher(formName){
      let params = {...this.addRequestForm};
      params.courseIds = params.courseIds.join();
      this.$refs[formName].validate((valid) => {
        if (valid) {
          ReviewTeacherSet(params).then( res => {
            if (res.code == 1) {
              this.$message.success("操作成功");
              this.downDialog = false;
              this.search();
            } else if (res.code == 0 && res.error.msg == '用户名已存在！') {
              this.addRequestForm.userName = '';
            }
          })
        } else {
          this.$message.error("请将评阅教师信息填写完整！");
          return false;
        }
      });
    },

    /**************************
     * @this 启用状态切换
     **************************/
    changeState(row){
      let params = {
        teacherId: row.teacherId,
        state: row.state
      }
      delReTeacher(params).then(res => {
        if (res.code == 1) {
          this.$message.success("操作成功");
        }
      })
    },

    /***********************
     * @this 导入按钮
     **********************/
    exportTeacher(){
      this.baseImportDialog = true;
    },

    /***********************
     * @this 导入模板处理
     **********************/ 
    handleFormData(val) {
      this.importForm.file = val.file;
    },

    /***********************
     * @this 执行导入
     **********************/ 
    async rightImport(){
      if (!this.importForm.file) {
        this.$message.error('请选择文件');
        return
      }
      const fd = new FormData();
      for (let item in this.importForm) {
        fd.append(item,this.importForm[item])
      }

      const { code, data } = await importReTeacher(fd);
      if (code == 1) {
        const failNum = data.errorCount ? parseInt(data.errorCount) : 0;
        const totalNum = parseInt(data.allCount);
        const successNum = totalNum - failNum;
        let message = `导入完成，成功导入${successNum}，失败人员数${failNum}`;
        this.baseImportDialog = false;
        this.$confirm(message, '导入结果', {
          confirmButtonText: failNum > 0 ? '查看错误记录' :'确定',
          cancelButtonText: '取消',
          type: failNum > 0 ? 'warning' :'success'
        }).then(async () => {
          if (failNum > 0) {
            window.location.href = data.address
          }
        }).catch(() => {          
        });
        this.search()
      }
    },
    
    /***********************
     * @this 删除
     **********************/
    delTeacher(row){
      let params = {
        teacherId: row.teacherId,
        state: 2
      };
      this.$confirm('是否确定删除教师?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { code } = await delReTeacher(params);
        if (code == 1) {
          this.$message.success("删除成功");
          this.search();
        }
      }).catch(() => {        
      })
    },
    
    /***********************
     * @this 重置密码按钮
     **********************/
    repeatPsd(row){
      this.resetDialog = true;
      this.resetPasswordForm = {
        teacherId: row.teacherId,
        userName: row.userName,
        teacherName: row.teacherName,
        password: "",
        repassword: "",
      }
    },

    /*************************
     * @this 确认密码验证
     *************************/
    confirmPassword(rule, value, callback) {
      if (value) {
        if (this.resetPasswordForm.password !== this.resetPasswordForm.repassword) {
          callback(new Error("设置密码和确认密码必须相同"));
        } else {
          callback();
        }
      }
      callback();
    },

    /***********************
     * @this 重置密码
     **********************/
    resetPasswordFn(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            userId : this.resetPasswordForm.teacherId,
            password: this.resetPasswordForm.password,
            confirmPassword: this.resetPasswordForm.repassword,
            tenant: window.localStorage.getItem('tenant')
          }
          editReviewPsd(params).then(res => {
            if (res.code == 1) {
              this.$message.success("操作成功！");
              this.resetDialog = false;
            }
          })
        } else {
          return false;
        }
      });     
    },

    /***********************
     * @this 验证手机号
     **********************/
    isCheckPhone(rule, value, callback){
      let phoneReg = /^1[3456789]\d{9}$/;
      if (phoneReg.test(value) || value=='') {
        callback();
      } else {
        callback(new Error('手机号格式错误'));
      }
    },

    /***********************
     * @this 全选/全不选
     **********************/
    handleCheckAllChange(val){
      if(val){
        // 清空课程选项,避免重复添加课程
        this.addRequestForm.courseIds = [];
        this.courseData.forEach(e=>{
          this.addRequestForm.courseIds.push(e.id);
        })
      } else {
        this.addRequestForm.courseIds = [];
      }
      this.isIndeterminate = false;
    },

    /***********************
     * @this 课程_checkbox
     **********************/
    handleCheckedUsersChange(value){
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.courseData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.courseData.length;
    },

    /***********************
     * @this 分页-每页数量
     **********************/
    changeNum(num) {
      this.requestForm.size = num;
      this.search();
    },

    /***********************
     * @this 分页-页码
     **********************/
    changePage(p) {
      this.requestForm.page = p;
      this.search();
    },
  }
}
</script>

<style lang="less" scoped>
// 新增: 启用状态
.addStatus {
  display: flex;
  /deep/ .el-form-item__label {
    line-height: 22px;
  }
}

// 新增: 课程
.checkCourse {
  width:100%;
  background: #F8F9FC;
  border-radius: 4px;
  padding: 19px 0 0 16px;
  margin-bottom: 22px;
  /deep/ .el-checkbox-group{
    display: flex;
    flex-wrap: wrap;
    .el-checkbox{
      margin-right: 0;
      margin-bottom: 12px;
      width:50%;
    }
  }      
}

// 处理账密自动填充问题
.no-autofill-pwd {
  /deep/ .el-input__inner {
    -webkit-text-security:disc!important;
  }
  /deep/ .el-form-item__content {
    width: 240px;
  }
}
.resetPassword /deep/ .el-form-item__content {
  width: 240px;
}

</style>

